import React, { createContext, useState } from "react";

import { ThemeProvider as ThemeProviderStyled } from "styled-components";
import { PrimaryTheme } from "./primary";
import { SecondaryTheme } from "./secondary";
import { ChildrenDefaultProps } from "../../models/children";

// eslint-disable-next-line no-shadow
export enum ThemeType {
    primary = "primary",
    secondary = "secondary",
}

const themes = {
    primary: PrimaryTheme,
    secondary: SecondaryTheme,
};

export const ThemeContext = createContext({
    theme: ThemeType.secondary,
    toggleTheme: () => {},
});

export const ThemeProvider: React.FunctionComponent<ChildrenDefaultProps> = ({
    children,
}) => {
    const [theme, setTheme] = useState(ThemeType.secondary);

    function toggleTheme() {
        if (theme === ThemeType.primary) {
            setTheme(ThemeType.secondary);
        } else {
            setTheme(ThemeType.primary);
        }
    }

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <ThemeProviderStyled theme={themes[theme]}>
                {children}
            </ThemeProviderStyled>
        </ThemeContext.Provider>
    );
};
